import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import IconButton from 'material-ui/IconButton';
import { incidentOperations } from '../../../../redux/incident';
import { resourceOperations } from '../../../../redux/resource';
import { configOperations } from '../../../../redux/config';

import Panel from './Panel';
import TabBar from './TabBar';
import ColumnChooser from '../../../common/DataGrid/ColumnChooser';
import {
  formatAttribute,
  applyFieldArrayOverrides,
  formatValue,
  defineIncident,
  getCurrentRouteFragment,
  arrayToLookup
} from '../../../../utils/helpers';


import {
  fetchExperiencesByIncidentID,
  fetchResourcesByIncidentID,
  fetchRequestsByIncidentID,
  fetchCTIDs,
  fetchCapabilitiesbyRequests
} from '../../../../esri/mapHub';

import DataGrid from '../../../common/DataGrid';
import DataGridHeader from '../../../common/DataGrid/DataGridHeader';
import resourceGridDefinitionJSON from '../../../../defaults/datagrids/incidentResources.json';
import requestGridDefinitionJSON from '../../../../defaults/datagrids/incidentRequests.json';
import experienceGridDefinitionJSON from '../../../../defaults/datagrids/incidentExperiences.json';


class ResourceHistory extends Component {
  constructor(props) {
    super(props);


    resourceGridDefinitionJSON.baseQuery = `ModifiedOnDateTime <= 1555941432000`;
    requestGridDefinitionJSON.baseQuery = `ModifiedOnDateTime <= 1555941432000`;
    experienceGridDefinitionJSON.baseQuery = `ModifiedOnDateTime <= 1555941432000`;


    this.state = {
      activeTable: 0,
      loading: true,
      requestLoading: false,
      requests: [],
      requestsResponse: [],
      resources: [],
      resourceFieldInfos: [],
      experiences: [],
      IrwinID: this.props.match.params.id,
      experienceResponse: [],
      capabilities: [],
      capabilityFieldInfos: [],
      capabilityFieldDefinitions: [],
      requestMerge: [],
      requestMergeFields: [],
      // requestMergeFieldsDefinitions: [],
      experienceMerge: [],
      experienceMergeFields: [],
      experienceMergeFieldsDefinitions: [],
      capabilitytypes: [],
      capabilitytypeFieldInfos: [],
      resourceGridDefinition: resourceGridDefinitionJSON,
      experienceGridDefinition: experienceGridDefinitionJSON,
      capabilityGridDefinition: experienceGridDefinitionJSON,
      requestGridDefinition: requestGridDefinitionJSON,
      isMore: true

    };

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const INCIDENT_ID = this.getIncidentID();
    const setExperienceData = this.setExperienceData.bind(this);
    const setResourceData = this.setResourceData.bind(this);
    const setRequestData = this.setRequestData.bind(this);
    const setCapabilityData = this.setCapabilityData.bind(this);
    const setCTIDData = this.setCTIDData.bind(this);
    // const setRelationshipData = this.setRelationshipData.bind(this);
    const handleError = this.handleError.bind(this);

    const setMergeData = this.setMergedData.bind(this);
    const setMergedExperienceData = this.setMergedExperienceData.bind(this);

    const updateResourceGridDefinitionFields = this.updateResourceGridDefinitionFields.bind(
      this
    );
    const updateRequestGridDefinitionFields = this.updateRequestGridDefinitionFields.bind(
      this
    );
    const updateExperienceGridDefinitionFields = this.updateExperienceGridDefinitionFields.bind(
      this
    );

    const updateCapabilityGridDefinitionFields = this.updateCapabilityGridDefinitionFields.bind(
      this
    );


    this.setState({ loading: false,  requestLoading: true});

    Promise.all([
      fetchRequestsByIncidentID(INCIDENT_ID).then(setRequestData, handleError),
      fetchResourcesByIncidentID(INCIDENT_ID).then(
        setResourceData,
        handleError
      ),

      //     if (response.features.length > 0)
      // ),
      /* /fetchResourcesByIncidentID(INCIDENT_ID).then(
        setRelationshipData,
        handleError
      ),/ */
      fetchExperiencesByIncidentID(INCIDENT_ID).then(
        setExperienceData,
        handleError
      ),
      fetchCapabilitiesbyRequests(INCIDENT_ID).then(
        setCapabilityData,
        handleError
      ),
      fetchCTIDs(INCIDENT_ID).then(setCTIDData, handleError)
    ]).then(() => {
      setMergeData();
      setMergedExperienceData();
      updateResourceGridDefinitionFields();
      updateRequestGridDefinitionFields();
      updateExperienceGridDefinitionFields();
      updateCapabilityGridDefinitionFields();
    }, handleError);

  }

  componentDidUpdate(prevProps, prevState) {
    if (

      prevProps.resourceFields !== this.props.resourceFields ||
      prevProps.resourceListColumns !== this.props.resourceListColumns ||
      prevProps.preferences.resourceListColumns !==
        this.props.preferences.resourceListColumns

    ) {
      this.updateResourceGridDefinitionFields();
    }

    if (
      prevProps.fields !== this.props.fields ||
      prevProps.incidentRequestListColumns !==
        this.props.incidentRequestListColumns ||
      prevProps.preferences.incidentRequestListColumns !==
        this.props.preferences.incidentRequestListColumns
    ) {
      this.updateRequestGridDefinitionFields();
    }

    if (
      prevProps.fields !== this.props.fields ||
      prevProps.incidentExperienceListColumns !==
        this.props.incidentExperienceListColumns ||
      prevProps.preferences.incidentExperienceListColumns !==
        this.props.preferences.incidentExperienceListColumns
    ) {
      this.updateExperienceGridDefinitionFields();
    }
  }

  /**
   * @func formatRequestData
   * @desc Formats the reponse for the resource capability requests.
   * @param {*} response
   * @param {Array.<Features>} response.features
   */
  setRequestData(response) {
    let { features = [], fields = [] } = response;

    if (features === null) {
      features = [];
    }

    if (fields === null) {
      fields = [];
    }

    // const FORMATTED_FIELDS = applyFieldArrayOverrides(fields, 'requestHistory');

    // const REQUEST_FIELD_DEFINITIONS = FORMATTED_FIELDS.map(
    //   this.formatFieldDefinition
    // );

    this.setState({
      requests: features.map(this.formatFeatures),
      requestsResponse: response,
      // requestFieldInfos: FORMATTED_FIELDS,
      // requestFieldDefinitions: REQUEST_FIELD_DEFINITIONS

    });
  }

  setCapabilityData(response) {
    let { features = [], fields = [] } = response;

    if (features === null) {
      features = [];
    }

    if (fields === null) {
      fields = [];
    }
    const FORMATTED_FIELDS = applyFieldArrayOverrides(
      fields,
      'capabilitiesHistory'
    );

    const CAPABILITY_FIELD_DEFINITIONS = FORMATTED_FIELDS.map(
      this.formatFieldDefinition
    );

    this.setState({
      capabilities: features.map(this.formatFeatures),
      // capabilitiesResponse: response,
      capabilityFieldInfos: FORMATTED_FIELDS,
      capabilityFieldDefinitions: CAPABILITY_FIELD_DEFINITIONS
    });
  }

  /* / setRelationshipData(resources) {
    const { features = [] } = resources;
    features.forEach(feature => {
      fetchResourceInfoById(feature.attributes.IrwinRID, {
        includeRelationships: true
      }).then(
        response => {
          if (!response) {
            return;
          }
          const feature = response;
          const { childRelationships = [], attributes = [] } = feature;
          const resrelationships = [];
          resrelationships.push(feature);
          console.log(feature, resrelationships);
          this.setState({
            resourceMod: resrelationships
          });
        },
        error => {
          console.error(error);
        }
      );
    });
  } / */

  setResourceData(response) {
    let { features = [], fields = [] } = response;
    if (features === null) {
      features = [];
    }
    if (features.length === 1 && response.exceededTransferLimit) {
      features = [];
    }

    if (fields === null) {
      fields = [];
    }

    const RESOURCE_FORMATTED_FIELDS = applyFieldArrayOverrides(
      fields,
      'resourceHistory'
    );

    // const RESOURCE_FIELD_DEFINITIONS = FORMATTED_FIELDS.map(
    //   this.formatFieldDefinition
    // );

    this.setState({
      // resources: features.map(this.formatFeatures),
      resources: features.map(this.formatFeatures),
      // resourceResponse: response,
      resourceFieldInfos: RESOURCE_FORMATTED_FIELDS,
      // resourceFieldDefinitions: RESOURCE_FIELD_DEFINITIONS
    });
  }

  setExperienceData(response) {
    let { features = [], fields = [] } = response;

    if (features === null) {
      features = [];
    }

    if (fields === null) {
      fields = [];
    }


    // const FORMATTED_FIELDS = applyFieldArrayOverrides(
    //   fields,
    //   'experienceHistory'
    // );

    // const EXPERIENCE_FIELD_DEFINITIONS = FORMATTED_FIELDS.map(
    //   this.formatFieldDefinition
    // );

    this.setState({
      experiences: features.map(this.formatFeatures),
      experienceResponse: response,
      // experienceFieldInfos: FORMATTED_FIELDS,
      // experienceFieldDefinitions: EXPERIENCE_FIELD_DEFINITIONS
    });
  }

  setCTIDData(response) {
    let { features = [], fields = [] } = response;

    if (features === null) {
      features = [];
    }

    if (fields === null) {
      fields = [];
    }

    const FORMATTED_FIELDS = applyFieldArrayOverrides(
      fields,
      'experienceHistory'
    );

    // const CTID_FIELD_DEFINITIONS = FORMATTED_FIELDS.map(
    //   this.formatFieldDefinition
    // );

    this.setState({
      capabilitytypes: features.map(this.formatFeatures),
      capabilitytypeFieldInfos: FORMATTED_FIELDS

    });
  }

  setMergedData() {
    const lineup = this.state.requestsResponse;
    let rowIndex;
    if (lineup.fields !== null) {
      const totalFields = lineup.fields.length;
      this.state.capabilities.forEach(capability => {
        // grab the matching lineup row if there is one

        // console.log(lineup);
        // console.log(capability);
        if (lineup.features) {
          rowIndex = lineup.features
              .map(o => o.attributes.IrwinCID)
              .indexOf(capability.attributes.IrwinCID);
          if (rowIndex >= 0) {
            lineup.features.map(o => {
              if (o.attributes.IrwinCID === capability.attributes.IrwinCID) {
                Object.assign(o.attributes, {
                  IrwinRID: capability.attributes.IrwinRID
                });
              }
            });
          }
        }
      });
      // if (rowIndex >= 0) {
      this.state.resources.forEach(resource => {
        // console.log(rowIndex, lineup.features);
        lineup.features.map(o => {
          if (o.attributes.IrwinRID === resource.attributes.IrwinRID) {
            Object.assign(o.attributes, {
              OperationalName: resource.attributes.OperationalName,
              OperationalStatus: resource.attributes.OperationalStatus
            });
            if (this.state.resourceFieldInfos[26] && this.state.resourceFieldInfos[25]
                && this.state.resourceFieldInfos[10]) {
              Object.assign(
                  lineup.fields,
                  {[totalFields + 1]: this.state.resourceFieldInfos[26]},
                  {[totalFields + 2]: this.state.resourceFieldInfos[25]},
                  {[totalFields + 3]: this.state.resourceFieldInfos[10]}
              );
            }
          }
        });
      });
      lineup.features.map(o => {
        if (!o.attributes.IrwinRID) {
          Object.assign(o.attributes, {
            OperationalName: 'N/A',
            IrwinRID: null,
            OperationalStatus: null
          });
        } else if (o.attributes.FulfillmentStatus === 'Closed' || o.attributes.FulfillmentStatus === 'Reassign') {
          Object.assign(o.attributes, {
            OperationalStatus: null
          });
        }
      });
      this.state.capabilitytypes.forEach(capabilitytype => {
        // console.log(rowIndex, lineup.features);
        lineup.features.map(o => {
          if (
              o.attributes.IrwinCTID === capabilitytype.attributes.IrwinCTID
          ) {
            Object.assign(o.attributes, {
              Type: capabilitytype.attributes.Type,
              Category: capabilitytype.attributes.Category
            });
            if (this.state.capabilitytypeFieldInfos[3] && this.state.capabilitytypeFieldInfos[2]) {
              Object.assign(lineup.fields, {
                [totalFields + 4]: this.state.capabilitytypeFieldInfos[3],
                [totalFields + 5]: this.state.capabilitytypeFieldInfos[2]
              });
            }
          }
        });
      });
      if (this.state.capabilities.length <= 0) {
        lineup.features.map(o => {
          if (!o.attributes.IrwinRID) {
            Object.assign(o.attributes, {
              OperationalName: 'N/A',
              IrwinRID: null,
              OperationalStatus: null
            });

          } else if (o.attributes.FulfillmentStatus === 'Closed' || o.attributes.FulfillmentStatus === 'Reassign') {
            Object.assign(o.attributes, {
              OperationalStatus: null
            });
          }
        });
        // }
      }
    }

    let {features = [], fields = []} = lineup;
    if (features === null) {
      features = [];
    }
    if (fields === null) {
      fields = [];
    }
    const FORMATTED_FIELDS = applyFieldArrayOverrides(fields, 'requestHistory');

    // const REQUESTTWO_FIELD_DEFINITIONS = FORMATTED_FIELDS.map(
    //   this.formatFieldDefinition
    // );


    this.setState({
      requestMerge: features.map(this.formatFeatures),
      requestMergeFields: FORMATTED_FIELDS,
      requestLoading: false,
      loading: false

    });

    this.props.setRequestFields(
      arrayToLookup(this.state.requestMergeFields, 'name')
    );

  }

  setMergedExperienceData() {
    const lineup = this.state.experienceResponse;

    // console.log(lineup);
    // let experienceLineup;
    if (this.state.experienceResponse.fields !== null) {
      const totalFields = lineup.fields.length;
      for (const requests of this.state.requestMerge) {
        // grab the matching lineup row if there is one
        let rowIndex;
        // console.log(lineup);
        // console.log(capability);
        if (lineup.features) {
          rowIndex = lineup.features
            .map(o => o.attributes.IrwinCID)
            .indexOf(requests.attributes.IrwinCID);
          if (rowIndex >= 0) {
            lineup.features.map(o => {
              if (o.attributes.IrwinCID === requests.attributes.IrwinCID) {
                Object.assign(o.attributes, {
                  IrwinRID: requests.attributes.IrwinRID,
                  OperationalName: requests.attributes.OperationalName,
                  Type: requests.attributes.Type
                });
              }
            });
            Object.assign(
                lineup.fields,
                {[totalFields + 1]: this.state.resourceFieldInfos[25]},
                {[totalFields + 2]: this.state.resourceFieldInfos[10]},
                {[totalFields + 3]: this.state.capabilitytypeFieldInfos[3]}
            );
            // console.log(lineup);
            // } else {
            //   // if the lineup was blank because there is no experience data
            //   return lineup;
            // }
          }
        }
        if (rowIndex >= 0) {
          if (lineup.features) {
            lineup.features.map(o => {
              if (!o.attributes.IrwinRID) {
                Object.assign(o.attributes, {
                  OperationalName: '',
                  IrwinRID: null
                });
              }
            });
          }
        }
      }
      let { features = [], fields = [] } = lineup;
      if (features === null) {
        features = [];
      }
      if (fields === null) {
        fields = [];
      }
      const FORMATTED_FIELDS = applyFieldArrayOverrides(
        fields,
        'experienceHistory'
      );

      const EXPERIENCE_MERGE_FIELD_DEFINITIONS = FORMATTED_FIELDS.map(
        this.formatFieldDefinition
      );
     // const experienceLineup = features.map(this.formatFeatures);

      this.setState({
        experienceMerge: features.map(this.formatFeatures),
        experienceMergeFields: FORMATTED_FIELDS,
        experienceMergeFieldsDefinitions: EXPERIENCE_MERGE_FIELD_DEFINITIONS
      });
    }

    // console.log(this.state.experienceMergeFields);
  }

  getIncidentID() {
    const {
      props: {
        match: {
          params: { id: incidentID }
        }
      }
    } = this;

    return incidentID;
  }

  // filterOperationalStatusFields = ({ name }) => {
  //   const OPERATIONAL_STATUS_FIELD_NAMES = {
  //     OperationalName: true,
  //     OperationalStatus: true
  //   };
  //
  //   if (name in OPERATIONAL_STATUS_FIELD_NAMES) {
  //     return true;
  //   }
  //
  //   return false;
  // };

  formatFieldDefinition = field => {
    const { alias, name } = field;
    return { alias, name, width: 250 };
  };

  formatFeatures = ({ attributes }) => ({
    attributes
  });

  handleError = err => {
    console.log(err);
  };

  /**
   *
   * @param {Array.<FieldInfo>} fieldInfos
   */
  convertFieldInfoArrToObj = fieldInfos => {
    const FORMATTED_FIELD_INFOS = {};

    fieldInfos.forEach(fieldInfo => {
      const { name } = fieldInfo;
      FORMATTED_FIELD_INFOS[name] = fieldInfo;
    });

    return FORMATTED_FIELD_INFOS;
  };

  getGridDefinitionFields = (columns, fields = []) =>
    fields.filter(({ name }) => columns.indexOf(name) > -1);


  getResourceActions = () => [];

  getRequestActions = () => [];

  getExperienceActions = () => [];

  getResourceDefinitionFields(resourceListColumns) {
    // loop over resourceListColumns,
    // lookup fields definition object from this.props.fields,
    // and return a new array
    // (intended to update the array used in this.state.gridDefinition.fields)
    if (this.props.resourceFields) {
      return resourceListColumns.map(
        columnName => this.props.resourceFields[columnName]
      );
    }

    return [];
  }

  // getRequestfinitionFields(requestListColumns) {
  //   // loop over resourceListColumns,
  //   // lookup fields definition object from this.props.fields,
  //   // and return a new array
  //   // (intended to update the array used in this.state.gridDefinition.fields)
  //   if (this.state.requestMergeFields) {
  //     return requestListColumns.map(
  //       columnName => this.props.requestMergeFields[columnName]
  //     );
  //   }
  //
  //   return [];
  // }

  updateResourceGridDefinitionFields() {
    let resourceListColumns = this.props.resourceListColumns;
    if (
      this.props.preferences &&
      this.props.preferences.resourceListColumns &&
      this.props.preferences.resourceListColumns.length
    ) {
      resourceListColumns = this.props.preferences.resourceListColumns;
    }
    const currColumns = resourceListColumns;

    const resourceGridDefinitionFields = this.getResourceDefinitionFields(
      currColumns
    );

    this.setState({
      resourceGridDefinition: {
        ...this.state.resourceGridDefinition,
        fields: resourceGridDefinitionFields
      }
    });
  }

  updateRequestGridDefinitionFields() {
    const {
      props: { preferences, incidentRequestListColumns },
      props: {
        preferences: { incidentRequestListColumns: preferredColumns }
      },
      state: { requestGridDefinition, requestMergeFields }
    } = this;
    let currColumns = incidentRequestListColumns;


    if (preferences && preferredColumns && preferredColumns.length) {
      currColumns = preferredColumns;
    }


    const requestGridDefinitionFields = this.getGridDefinitionFields(
      currColumns,
      requestMergeFields
    );

    this.setState({
      requestGridDefinition: {
        ...requestGridDefinition,
        fields: requestGridDefinitionFields

      }
    });
  }

  updateCapabilityGridDefinitionFields() {

    const {
      props: { preferences, incidentRequestListColumns },
      props: {
        preferences: { incidentRequestListColumns: preferredColumns }
      },

      state: { capabilityGridDefinition, capabilityFieldDefinitions }

    } = this;
    let currColumns = incidentRequestListColumns;

    if (preferences && preferredColumns && preferredColumns.length) {
      currColumns = preferredColumns;
    }


    const capabilityGridDefinitionFields = this.getGridDefinitionFields(
      currColumns,
      capabilityFieldDefinitions
    );

    this.setState({
      capabilityGridDefinition: {
        ...capabilityGridDefinition,
        fields: capabilityGridDefinitionFields

      }
    });
  }

  updateExperienceGridDefinitionFields() {
    const {
      props: { preferences, incidentExperienceListColumns },
      props: {
        preferences: { incidentExperienceListColumns: preferredColumns }
      },

      state: { experienceGridDefinition, experienceMergeFieldsDefinitions }

    } = this;
    let currColumns = incidentExperienceListColumns;

    if (preferences && preferredColumns && preferredColumns.length) {
      currColumns = preferredColumns;
    }

    const experienceGridDefinitionFields = this.getGridDefinitionFields(
      currColumns,
      experienceMergeFieldsDefinitions
    );
    // console.log(experienceGridDefinitionFields);


    this.setState({
      experienceGridDefinition: {
        ...experienceGridDefinition,
        fields: experienceGridDefinitionFields
      }
    });
  }

  handleChange(evt, newValue) {
    this.setState({
      activeTable: newValue
    });
  }

  getActions = () => [
    <IconButton
      tooltip="View Resource"
      tooltipPosition="bottom-left"
      key="viewResourceBtn"
    >
      <i className="grid-action-icon esri-icon-review" />
    </IconButton>
  ];

  render() {
    const {
      activeTable: value,
      loading,
      requestLoading,
      requests,
      // requestsResponse,
      resources,
      resourceFieldInfos,
      experiences,
      requestGridDefinition,
      resourceGridDefinition,
      experienceGridDefinition,
      requestMerge,
      requestMergeFields,
      experienceMerge,
      experienceMergeFields,
      // isMore
    } = this.state;

    const {
      addResourceListColumn,
      removeResourceListColumn,
      setInitialResourceListColumns,

      addIncidentRequestListColumn,
      removeIncidentRequestListColumn,
      setInitialIncidentRequestListColumns,
      addIncidentExperienceListColumn,
      removeIncidentExperienceListColumn,
      setInitialIncidentExperienceListColumns
    } = this.props;

    const { dataGridOptions } = this.props.appConfig;

    // const resourceReq = merge(requests, resources);

    const { handleChange } = this;
    const RESOURCE_FIELDS = this.convertFieldInfoArrToObj(resourceFieldInfos);
    const REQUEST_FIELDS = this.convertFieldInfoArrToObj(requestMergeFields);
    const EXPERIENCE_FIELDS = this.convertFieldInfoArrToObj(
      experienceMergeFields
    );

    return (
      <Fragment>
        <TabBar value={value} handleChange={handleChange} />
        <Panel value={value} index={0}>
          {resources.length > 0 ? (
            <div>
              <DataGridHeader
                title="Resources"
                itemCount={resources.length}
                headerStyleOverride={STYLES.header}
              />
              <DataGrid
                api="resource"
                attributeFormatter={formatAttribute}
                fieldDefinitions={resourceGridDefinition.fields}
                fieldInfos={resourceFieldInfos}
                filterable
                items={resources}
                itemCount={resources.length}
                pageSize={dataGridOptions.defaultPageSize}
                loading={loading}
                static

                resourceHistory
                updateItems={this.updateResourceList}
                actions={this.getResourceActions()}
                actionsHeader={
                  <ColumnChooser
                    columns={RESOURCE_FIELDS}
                    selectedColumns={resourceGridDefinition.fields}
                    addColumn={addResourceListColumn}
                    removeColumn={removeResourceListColumn}
                    reorderColumn={addResourceListColumn}
                    resetColumns={setInitialResourceListColumns}
                  />
                }
              />
            </div>
          ) : (
            <h3>No resource data available.</h3>
          )}
        </Panel>
        <Panel value={value} index={1}>
          {requests.length > 0 ? (
            <div>
              <DataGridHeader
                title="Requests"
                itemCount={requests.length}
                headerStyleOverride={STYLES.header}
              />
              <DataGrid
                api="resource.request"
                attributeFormatter={formatAttribute}
                fieldDefinitions={requestGridDefinition.fields}
                fieldInfos={requestMergeFields}
                items={requestMerge}
                itemCount={requestMerge.length}
                pageSize={dataGridOptions.defaultPageSize}
                loading={requestLoading}
                static
                resourceHistory
                actions={this.getRequestActions()}
                actionsHeader={
                  <ColumnChooser
                    addColumn={addIncidentRequestListColumn}
                    columns={REQUEST_FIELDS}
                    removeColumn={removeIncidentRequestListColumn}
                    reorderColumn={addIncidentRequestListColumn}
                    resetColumns={setInitialIncidentRequestListColumns}
                    selectedColumns={requestGridDefinition.fields}
                  />
                }
              />
            </div>
          ) : (
            <h3>No request data available.</h3>
          )}
        </Panel>
        <Panel value={value} index={2}>

          {experienceMerge.length > 0 ? (

            <div>
              <DataGridHeader
                title="Experiences"
                itemCount={experiences.length}
                headerStyleOverride={STYLES.header}
              />

              <DataGrid
                api="experiences"
                attributeFormatter={formatAttribute}
                fieldDefinitions={experienceGridDefinition.fields}

                fieldInfos={experienceMergeFields}
                items={experienceMerge}
                itemCount={experienceMerge.length}
                pageSize={dataGridOptions.defaultPageSize}
                loading={loading}
                static
                resourceHistory
                actions={this.getExperienceActions()}
                actionsHeader={
                  <ColumnChooser
                    addColumn={addIncidentExperienceListColumn}
                    columns={EXPERIENCE_FIELDS}
                    removeColumn={removeIncidentExperienceListColumn}
                    reorderColumn={addIncidentExperienceListColumn}
                    resetColumns={setInitialIncidentExperienceListColumns}
                    selectedColumns={experienceGridDefinition.fields}

                  />
                }
              />
            </div>
          ) : (
            <h3>No experience data available.</h3>
          )}
        </Panel>
      </Fragment>
    );
  }
}

const STYLES = {
  header: {
    margin: '0 0 0 0',
    border: '1px solid lightgray',
    borderBottom: '0',
    padding: '10px 20px'
  }
};

const mapStateToProps = state => ({
  map: state.map,
  appConfig: state.config,
  filters: state.incident.filters,
  sql: state.incident.sql,
  dataGridFilters: state.dataGridFilters,
  fields: state.incident.fields,
  resourceFields: state.resource.fields,
  request: state.resource.request,
  incidentListColumns: state.incident.incidentListColumns,
  incidentResourceListColumns: state.incident.incidentResourceListColumns,
  incidentRequestListColumns: state.incident.incidentRequestListColumns,
  incidentExperienceListColumns: state.incident.incidentExperienceListColumns,
  resourceListColumns: state.resource.resourceListColumns,
  resourceGridDefinition: state.resourceGridDefinition,
  preferences: state.config.preferences,
  resource: state.resource.resource

});

const mapDispatchToProps = function(dispatch) {
  return bindActionCreators(
    {
      ...incidentOperations,
      ...resourceOperations,
      ...configOperations
    },
    dispatch
  );
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ResourceHistory)
);



// WEBPACK FOOTER //
// ./src/components/incidents/IncidentDetails/ResourceHistory/index.js